import { LastWebsocketJsonMessageType } from '@interfaces/webSocketConnectionInfo';

const useHandleWebsocketMsg = (
  _lastJsonMessage: LastWebsocketJsonMessageType,
) => {
  //for myta specific
};

export default useHandleWebsocketMsg;
